<template>
  <generic-modal :title="$t('category details')" ref="generic_modal">
    <div class="columns" v-if="meta.name">
      <div class="column">
        <div class="box">
          <h2 class="title is-5">{{ $t("category information") }}</h2>
          <div class="field">
            <label class="label">{{ $t("category name") }}</label>
            <p class="has-text-weight-semibold">{{ meta.name }}</p>
          </div>
          <div class="field">
            <label class="label">{{ $t("color") }}</label>
            <span
              class="tag"
              :style="{ backgroundColor: meta.color, color: 'white' }"
              >{{ meta.color }}</span
            >
          </div>
          <div class="field">
            <label class="label">{{ $t("status") }}</label>
            <span
              class="tag"
              :class="meta.is_active ? 'is-success' : 'is-danger'"
            >
              {{ meta.is_active ? $t("active") : $t("inactive") }}
            </span>
          </div>
          <div class="field" v-if="meta.description">
            <label class="label">{{ $t("description") }}</label>
            <p>{{ meta.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>

    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="edit_category"
        v-if="meta.uuid"
      >
        <span class="icon"><i class="fa fa-edit"></i></span>
        <span>{{ $t("edit") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon"><i class="fa fa-close"></i></span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import { get, generate_error_message_text } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "CategoryDetailModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  methods: {
    close_modal() {
      this.$refs.generic_modal.close_modal();
      this.set_initial_state();
    },
    show_modal(uuid = null) {
      this.set_initial_state();
      if (uuid) {
        get("/archive/category", { uuid })
          .then((category) => {
            this.meta = category;
            this.$refs.generic_modal.show_modal();
          })
          .catch((error) => {
            this.error = generate_error_message_text(error);
          });
      }
    },
    edit_category() {
      this.$emit("edit", this.meta.uuid);
      this.close_modal();
    },
    set_initial_state() {
      this.meta = {};
      this.error = "";
    },
  },
};
</script>
